module.exports = __webpack_public_path__ + "static/media/coffee_mugs.fa8578c9.gif";